<template>
  <div id="user">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" @click="show('c',null)" v-if="roles.indexOf('1')>-1">新增</el-button>
        </el-form-item>
        <el-form-item>
          <p>默认密码为 账号名+12345678</p>
        </el-form-item>
      </el-form>
    </el-col>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.length"
        style="float:left;"
      ></el-pagination>
    </el-col>

    <!-- 列表 -->
    <el-table
      :data="tableData.slice((page-1)*pageSize,page*pageSize)"
      border
      style="width: 100%"
      v-loading="listLoading"
    >
      <el-table-column prop="username" label="账号" width="150px"></el-table-column>
      <el-table-column prop="realName" label="姓名" width="100px"></el-table-column>
      <el-table-column prop="sex" label="性别" width="60px">
        <template slot-scope="scope">
          <img
            src="@/assets/img/man.jpg"
            v-if="scope.row.sex=='male'"
            style="width:30px;height:30px"
          />
          <img src="@/assets/img/woman.jpg" v-else style="width:30px;height:30px" />
        </template>
      </el-table-column>
      <el-table-column prop="joinTime" label="注册时间"></el-table-column>
      <el-table-column prop="lastLogin" label="最后登陆"></el-table-column>
      <el-table-column prop="userRoles" label="角色"></el-table-column>
      <el-table-column label="状态" width="80px">
        <template slot-scope="scope">
          <template v-if="scope.row.isActivate">
            <p>正常</p>
          </template>
          <template v-else>
            <p style="color:red;">已停用</p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <template v-if="!scope.row.isActivate">
            <el-button type="text" @click="doDelete(scope.row,true)" v-if="roles.indexOf('1')>-1">激活</el-button>
          </template>
          <template v-else>
            <el-button type="text" @click="show('u',scope.row)" v-if="roles.indexOf('3')>-1">修改</el-button>
            <el-button
              type="text"
              @click="doDelete(scope.row,false)"
              v-if="roles.indexOf('2')>-1"
            >停用</el-button>
            <el-button
              type="text"
              @click="reset(scope.row.username)"
              v-if="roles.indexOf('3')>-1"
            >密码重置</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗界面-->
    <el-dialog
      :title="editForm.title"
      :visible.sync="editForm.isShow"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        label-position="right"
        @submit.native.prevent
        style="margin-right:60px"
        :rules="rules"
        ref="editForm"
        :close="init"
      >
        <el-form-item label="账号" required prop="username">
          <el-input v-model="editForm.username" :disabled="postApi.crud == 'u'"></el-input>
        </el-form-item>
        <el-form-item label="姓名" required prop="realName">
          <el-input v-model="editForm.realName"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="editForm.sex">
            <el-radio label="male">
              <img src="@/assets/img/man.jpg" style="width:30px;height:30px" />
            </el-radio>
            <el-radio label="female">
              <img src="@/assets/img/woman.jpg" style="width:30px;height:30px" />
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input v-model="editForm.email"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select
            v-model="editForm.userRoles"
            multiple
            placeholder="请选择"
            clearable
            style="width:300px"
          >
            <el-option v-for="(item, index) in all_roles" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="init">取消</el-button>
        <el-button type="primary" @click="commit" :loading="editForm.confirmLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      tableData: [],
      editForm: {},

      postApi: {
        crud: "",
        info: {}
      },

      page: 1, //分页显示信息
      pageSize: 10,
      pageSizes: [10, 20, 30, 40],

      listLoading: false,

      all_roles: [],

      rules: {
        email: [
          {
            type: "email", //要检验的类型（number，email，date等）
            message: "请输入正确的邮箱地址",
            trigger: "change"
          }
        ],
        phone: [
          {
            pattern: /^1[34578]\d{9}$/, //可以写正则表达式呦呦呦
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        username: {
          required: true, //是否必填
          message: "账号不能为空", //错误提示信息
          trigger: "blur" //检验方式（blur为鼠标点击其他地方，）
        },
        realName: {
          required: true, //是否必填
          message: "姓名不能为空", //错误提示信息
          trigger: "blur" //检验方式（blur为鼠标点击其他地方，）
        }
      }
    };
  },
  methods: {
    doSelect: async function() {
      this.listLoading = true;
      this.postApi.crud = "r";
      let res = await this.$doPost("/api/user", this.postApi);
      if (res.msgCode == 0) {
        this.tableData = res.result.infos.allUser;
        this.all_roles = res.result.infos.allRoles;
        // console.log(this.tableData);
      } else {
        this.$message.error(this.message.msg);
      }
      this.listLoading = false;
    },
    doDelete: async function(user, state) {
      this.postApi.crud = "d";
      this.postApi.info = { username: user.username, isActivate: state };
      let res = await this.$doPost("/api/user", this.postApi);
      if (res.msgCode == 0) {
        if (state) {
          this.$message.success(user.username + "已激活");
        } else {
          this.$message.success(user.username + "已停用");
        }
        user.isActivate = state;
      } else {
        this.$message.error(res.msg);
      }
    },
    init() {
      this.editForm = {
        isShow: false,
        title: "",
        username: "",
        realName: "",
        sex: "male",
        email: "",
        phone: "",
        userRoles: "",
        confirmLoading: false
      };
      if (this.$refs["editForm"] != null) {
        this.$refs["editForm"].resetFields();
      }
    },
    show(method, row) {
      switch (method) {
        case "c":
          this.postApi.crud = "c";
          this.editForm = {
            isShow: true,
            title: "新增用户",
            username: "",
            realName: "",
            sex: "male",
            email: "",
            phone: "",
            userRoles: ""
          };
          break;
        case "u":
          this.postApi.crud = "u";
          this.editForm = {
            isShow: true,
            title: "用户修改",
            username: row.username,
            realName: row.realName,
            sex: row.sex,
            email: row.email,
            phone: row.phone,
            userRoles: row.userRoles.split(",")
          };
          break;
        default:
          break;
      }
    },
    commit: async function() {
      let _this = this;
      this.$refs["editForm"].validate(async valid => {
        if (valid) {
          _this.editForm.confirmLoading = true;
          _this.postApi.info = _this.editForm;
          let res = await _this.$doPost("/api/user", _this.postApi);
          if (res.msgCode == 0) {
            _this.$message.success("操作成功");
          } else {
            _this.$message.error(res.msg);
          }
          _this.init();
          _this.doSelect();
        } else {
          _this.$message.error("请填写正确信息");
          return false;
        }
      });
      // this.$refs.editForm.validate(valid => {
      //   if (valid) {
      //     alert("submit!");
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    reset: async function(user) {
      this.postApi.crud = "upwd";
      this.postApi.info = { username: user };
      let res = await this.$doPost("/api/user", this.postApi);
      if (res.msgCode == 0) {
        this.$message.success(user + " 密码重置成功");
      }
    },
    //每页多少条
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
    },
    //当前第几页
    handleCurrentChange(val) {
      this.page = val;
    },
    getAllRules: async function() {}
  },
  created() {
    this.init();
    this.doSelect();
  },
  props: {
    roles: Array
  },
  // watch:{
  //   editForm: function
  // }
};
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/mysys/User.vue